import React from 'react';

import {Box} from '@mui/material';

import Footer from './Footer';
import Header from './Header';
import MainContent from './MainContent';
import SubContent from './SubContent';

export default function SideBar({ isMiddleSideBar, onToggleSideBar }) {
    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                minHeight: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: isMiddleSideBar ? 'stretch' : 'center'
            }}
        >
            <Header isMiddleSideBar={isMiddleSideBar} onToggleSideBar={onToggleSideBar} />
            <SubContent isMiddleSideBar={isMiddleSideBar} />
            <MainContent isMiddleSideBar={isMiddleSideBar} />
            <Footer isMiddleSideBar={isMiddleSideBar} />
        </Box>
    );
}
